import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from './../../../shared/components/base-form/base-form.component';
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { IOsaExecucaoModel } from "src/app/models/osa-execucao-model";
import { MatTableDataSource } from "@angular/material/table";
import { IOsaExecucaoSubtipoAuditoriaModel } from "src/app/models/osa-execucao-subtipo-auditoria.model";
import { IPermissaoModel } from "src/app/models/permissao.model";
import { AuthService } from "src/app/services/auth.service";
import { EnumRecursoPerfil } from "src/app/models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "src/app/models/enum/acao-recurso.enum";
import { OsaExecucaoService } from "src/app/services/osa-execucao.service";
import { OsaExecucaoCustoEquipeService } from "src/app/services/osa-execucao-custo-equipe.service";
import { OsaService } from "src/app/services/osa.service";
import { OsaExecucaoCustoRecursoService } from "src/app/services/osa-execucao-custo-recurso.service";
import { OsaExecucaoCronogramaService } from "src/app/services/osa-execucao-cronograma.service";
import { OsaExecucaoFolhaTesteService } from "src/app/services/osa-execucao-folha-teste.service";
import { OsaExecucaoProgramaTrabalhoService } from "src/app/services/osa-execucao-programa-trabalho.service";
import { OsaExecucaoPapelTrabalhoService } from "src/app/services/osa-execucao-papel-trabalho.service";
import { IOsaExecucaoFiltroModel } from 'src/app/models/osa-execucao-model';
import { NotaAuditoriaExecucaoService } from "src/app/services/nota-auditoria-execucao.service";
import { SolicitacaoTecnicaService } from "src/app/services/solicitacao-tecnica.service";
import { SharedService } from "../../../services/shared.service";
import { MatrizConstatacoesService } from "src/app/services/matriz-constatacao.service";

@Component({
  selector: 'app-osa-execucao-form',
  templateUrl: './osa-execucao-form.component.html',
  styleUrls: ['./osa-execucao-form.component.scss']
})
export class OsaExecucaoFormComponent extends BaseFormComponent implements OnInit {
  public model: IOsaExecucaoModel = {} as IOsaExecucaoModel;
  public subtipoDataSource = new MatTableDataSource<IOsaExecucaoSubtipoAuditoriaModel>([]);
  public permissoes: IPermissaoModel;
  public elaborar = true;
  public versao: boolean;
  public isFilha: boolean = false;
  public enviandoParaAprovacao = false;
  public filtro: IOsaExecucaoFiltroModel = {} as IOsaExecucaoFiltroModel;
  public statusOsaExecucao: number;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private osaExecucaoService: OsaExecucaoService,
    private osaExecucaoCustoEquipeService: OsaExecucaoCustoEquipeService,
    private osaExecucaoCustoRecursoService: OsaExecucaoCustoRecursoService,
    private osaService: OsaService,
    private cronogramaService: OsaExecucaoCronogramaService,
    private serviceOsaExecucaoFolhaTeste: OsaExecucaoFolhaTesteService,
    private serviceOsaExecucaoProgramaTrabalho: OsaExecucaoProgramaTrabalhoService,
    private osaExecucaoPapelTrabalhoService: OsaExecucaoPapelTrabalhoService,
    private notaAuditoriaService: NotaAuditoriaExecucaoService,
    private solicitacaoTecnicaService: SolicitacaoTecnicaService,
    private matrizConstatacoesService: MatrizConstatacoesService,
    public sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.titulo = 'Executar';
  }

  ngOnInit(): void {
    this.obterDados();
    this.setarPermissoes();
    if (this.visualizar) {
      this.titulo = 'Visualizar'
    }
    else {
      this.titulo = 'Executar'
    }
  }

  private setarPermissoes(): void {
    this.permissoes = new IPermissaoModel();
    this.permissoes.enviarParaAprovacao = this.authService.possuiPermissao(EnumRecursoPerfil.AuditoriaExecucao, EnumAcaoRecurso.EnviarParaAprovacao);
  }

  public async obterDados() {
    try {
      const res = await this.osaExecucaoService.obterPorId(this.id);

      if (res.sucesso) {
        this.model = res.dados;
        this.statusOsaExecucao = res.dados.status.codigo;
        if (this.statusOsaExecucao === 3) {
          this.visualizar = true;
        }

        this.sharedService.setstatusOsaExecucao(this.model.status.codigo);
        this.sharedService.setNomeAuditor(this.model?.osa?.nomeAuditor);

      }
    } catch (err) {
      this.submit = false;
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/osa-execucao']);
    }
  }

  public mudarAba(ind: number) {
    this.aba = ind;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { aba: ind },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }


  public async enviarParaAprovacao() {
    try {
      // Inicia o loading
      this.enviandoParaAprovacao = true;
      this.spinner.show();

      //Aba Custos e Recursos
      const custoEquipe = await this.osaExecucaoCustoEquipeService.obterPorExecucao(this.id, 2);

      const coordenador = custoEquipe.dados.find(x => x.nomeAgente === this.model?.osa?.nomeAuditor);

      if (!coordenador) {
        this.exibirMensagemAlerta("[Aba Custos e Recursos]: É necessário que o Coordenador tenha registro em Custos de Equipe e outros servidores da seção Custos e Recursos");
        return;
      }

      const siglaUg = this.model?.osa?.unidadeGestora?.sigla;
      const equipeAuditores = await this.osaService.obterAlocarEquipeOsaId(this.model.osa.id, siglaUg);


      const equipeAuditoresDistintos = [...new Map(equipeAuditores.dados.map(a => [JSON.stringify(a), a])).values()];

      const possuiTodaEquipeAuditores = equipeAuditoresDistintos.every(auditor =>
        custoEquipe.dados.some(x => x.nomeAgente === auditor.nomeAuditor));

      const possuiCustoEquipeServidoresIncompleto = (custoEquipe.dados ?? []).some(x => x.salario == 0 || x.custoFinal == 0);

      if (!possuiTodaEquipeAuditores || possuiCustoEquipeServidoresIncompleto) {
        this.exibirMensagemAlerta("[Aba Custos e Recursos] - É necessário que todos os auditores adicionados na Equipe de Auditoria tenham, no mínimo, um registro no campo de “Custos de equipe e outros servidores” da seção “Custos e Recursos Utilizados – Execução”.");
        return;
      }

      const custoRecursos = await this.osaExecucaoCustoRecursoService.obterPorExecucao(this.id, 2)

      const possuiCustoRecursosIncompleto = (custoRecursos.dados ?? []).some(x => x.valorUnitario == 0 || x.quantidade == 0);

      if (possuiCustoRecursosIncompleto) {
        this.exibirMensagemAlerta("[Aba Custos e recursos] Os registros da seção “Outros Custos e Recursos” devem estar preenchidos com valores válidos.");
        return;
      }

      //Aba Cronograma
      const cronograma = await this.cronogramaService.obterCronograma(this.id);
      const possuiCronogramaIncompleto = (cronograma.dados.fases ?? []).some(x => x.quantidadeDiasExec == 0 || x.quantidadeDiasPlan == 0 ||
        x.atividades.some(y => y.quantidadeDiasExec == 0));

      if (possuiCronogramaIncompleto) {
        this.exibirMensagemAlerta("[Aba Cronograma] - É necessário que as fases e as atividades, se houver, estejam com quantidade de dias executados diferente de zero.");
        return;
      }

      //Aba Nota de Auditoria
      var notas = await this.notaAuditoriaService.obter(this.id);

      const possuiNotaStatusIrregular = (notas.dados ?? []).some(x => x.status.codigo == 1 || x.status.codigo == 2 || x.status.codigo == 5);

      if (possuiNotaStatusIrregular) {
        this.exibirMensagemAlerta("[Aba Nota de Auditoria] - Existem Notas de Auditoria “Em elaboração”, “Finalizado” ou “Solicitação de Prorrogação”.");
        return;
      }

      const possuiNotaIrregular = (notas.dados ?? []).some(x => x.status.codigo != 4 && x.item.some(y => y.status.codigo != 3 && (y.statusAvaliacao == null ||
        (typeof y.statusAvaliacao === 'object' && Object.keys(y.statusAvaliacao).length === 0))));

      if (possuiNotaIrregular) {
        this.exibirMensagemAlerta("[Aba Nota de Auditoria] - Existe resposta de constatação da Nota de Auditoria não avaliada.");
        return;
      }

      //Aba Folhas testes e Programa de Trabalho
      const listaAgrupadaFolhaTeste = await this.serviceOsaExecucaoFolhaTeste.obterFolhaTestePorExecucao(this.id);
      const possuiFolhaTesteIrregular = (listaAgrupadaFolhaTeste.dados ?? []).some(x => x.status == 1 || x.status == 2);

      const listaProgramaTrabalho = await this.serviceOsaExecucaoProgramaTrabalho.obterProgramaTrabalhoPorExecucao(this.id);
      const possuiProgramaTrabalhoIrregular = (listaProgramaTrabalho.dados ?? []).some(x => x.status == 1 || x.status == 2);

      if (possuiFolhaTesteIrregular || possuiProgramaTrabalhoIrregular) {
        this.exibirMensagemAlerta("[Aba Folhas testes e Programa de Trabalho] - Existem Folhas testes e/ou Programa de Trabalho não finalizado.");
        return;
      }

      //Aba Matriz de Constatações

      const matrizDefinitiva = await this.matrizConstatacoesService.obterMatrizDefinitiva(this.id);

      const possuiMatrizIrregular = !matrizDefinitiva?.dados || matrizDefinitiva?.dados?.status !== 3;

      const matrizDefinitivaConsolidada = await this.matrizConstatacoesService.obterMatrizDefinitivaConsolidada(this.id);

      const possuiMatrizConsolidadaIrregular = !!matrizDefinitivaConsolidada?.dados && matrizDefinitivaConsolidada.dados.status !== 3;


      if (possuiMatrizIrregular || possuiMatrizConsolidadaIrregular) {
        this.exibirMensagemAlerta("[Aba Matriz de Constatações] - É necessário que a Matriz de Constatações esteja finalizada.");
        return;
      }

      //Aba Solicitação Técnica
      const solicitacoesTecnicas = await this.solicitacaoTecnicaService.obter(this.id, "execucao")

      const possuiSolicitacoesTecnicasStatusIrregular = (solicitacoesTecnicas.dados ?? []).some(x => x.status.codigo == 1 || x.status.codigo == 2 || x.status.codigo == 5);

      if (possuiSolicitacoesTecnicasStatusIrregular) {
        this.exibirMensagemAlerta("[Aba Solicitação Técnica] - Existem solicitações técnicas “Em elaboração”, “Finalizado” ou “Solicitação Prorrogação”.");
        return;
      }

      const possuiSolicitacoesTecnicasIrregular = (solicitacoesTecnicas.dados ?? []).some(x => x.status.codigo != 4 && x.item.some(y => y.status.codigo != 3 && (y.statusAvaliacao == null ||
        (typeof y.statusAvaliacao === 'object' && Object.keys(y.statusAvaliacao).length === 0))));

      if (possuiSolicitacoesTecnicasIrregular) {
        this.exibirMensagemAlerta("[Aba Solicitação Técnica] - Existem item de solicitação técnica não avaliado.");
        return;
      }

      //Aba Papéis de Trabalho
      const papeis = await this.osaExecucaoPapelTrabalhoService.obterPorExecucao(this.id);
      const possuiPapeisIrregulares = (papeis.dados ?? []).some(x => x.situacaoNome === "Obrigatório" && ((x.idTipoAceitavel != 2 && ((!x.arquivos || x.arquivos.length === 0) && (!x.justificativa || x.justificativa == ""))) || (x.idTipoAceitavel == 2 && ((!x.link || x.link == "") && (!x.justificativa || x.justificativa == "")))));

      if (possuiPapeisIrregulares) {
        this.exibirMensagemAlerta("[Aba Papéis] - Existem papéis de trabalho obrigatórios/opcionais sem anexos, sem link ou sem justificativa informada.");
        return;
      }

      //Aba Relatoria
      if (this.model.osa.statusUg == "Principal") {
        const UgsSecundarias = this.model.osaExecucaoUgSubTipo.filter(x => x.statusUg == "Subsidiária");
        var possuiUgsSecundariasNaoHomologadas = false;

        for (const ug of UgsSecundarias) {
          this.filtro.numeroOsaObjeto = ug.numeroOsa;
          const ugSec = await this.osaExecucaoService.obter(this.filtro);
          if (ugSec.resultado[0].status?.nome != 'Homologada') {
            possuiUgsSecundariasNaoHomologadas = true;
            break;
          }
        }

        if (possuiUgsSecundariasNaoHomologadas) {
          this.exibirMensagemAlerta("[Aba Relatoria] – É necessário que a “Relatoria de UG Subsidiária esteja homologada.");
          return;
        }
      }

      const res = await this.osaExecucaoService.enviarAprovacao(this.id);

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        this.router.navigate(['/osa-execucao']);
      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao || 'Erro inesperado',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    } finally {
      // Para o loading sempre, independente do resultado
      this.enviandoParaAprovacao = false;
      this.spinner.hide();
    }
  }

  public onBack() {
    this.router.navigate(["/osa-execucao"]);
  }

}
